import { TraceabilityNodeType } from '@v2/pages/common/components/TraceabilityGraph/types';

export const TRACEABILITY_GRAPH_MAX_VISIBLE_ITEMS = 3;

// Deterministic layout geometry (raw units — pass through scale() at the call site).
// Column X positions and connector paths are derived from these so the graph is
// reproducible regardless of how many entities each column holds.
export const TRACEABILITY_GRAPH_GEOMETRY = {
  columnWidth: 188,
  columnGap: 66,
  cardGap: 14,
  cardMinHeight: 96,
  headerHeight: 30,
  portRadius: 4,
  curveStrokeWidth: 1.5,
  // Horizontal pull of the bezier control points as a fraction of the gap (n8n-style flow).
  curvature: 0.6,
} as const;

// Diameter of the connector port dot (raw units — pass through scale() at the call site).
export const TRACEABILITY_GRAPH_PORT_SIZE = TRACEABILITY_GRAPH_GEOMETRY.portRadius * 2;

export const TRACEABILITY_GRAPH_NODE_CONFIG = {
  [TraceabilityNodeType.PART]: {
    icon: 'partsSelected',
    accentColor: 'Status/Light/Active',
  },
  [TraceabilityNodeType.PRODUCTION_ORDER]: {
    icon: 'productionOrderSelected',
    accentColor: 'Link/Light/Primary',
  },
  [TraceabilityNodeType.JOB]: {
    icon: 'jobsListSelected',
    accentColor: 'Status/Light/Setup',
  },
  [TraceabilityNodeType.BATCH]: {
    icon: 'batchActual',
    accentColor: 'Status/Light/Change',
  },
  [TraceabilityNodeType.MACHINE]: {
    icon: 'machineSelected',
    accentColor: 'Button/Light/Primary',
  },
  [TraceabilityNodeType.NC_FILE]: {
    icon: 'NCFileSelected',
    accentColor: 'Selected/Light/Primary',
  },
  [TraceabilityNodeType.VERSIONS]: {
    icon: 'compareVersions',
    accentColor: 'Button/Light/Primary',
  },
  [TraceabilityNodeType.DOCUMENTS]: {
    icon: 'files',
    accentColor: 'Link/Light/Primary',
  },
  [TraceabilityNodeType.EVENTS]: {
    icon: 'clock',
    accentColor: 'Status/Light/Active',
  },
  [TraceabilityNodeType.SUMMARY]: {
    icon: 'linkChain',
    accentColor: 'Label/Light/Tertiary',
  },
} as const;
